<template>
  <div class="form-group">
    <div>
      <span class="title">{{ title }} </span>
      <compact-picker v-model.trim="color.hex" />
    </div>
  </div>
</template>

<script>
import { Chrome } from "vue-color";

export default {
  name: "Color",
  components: {
    "compact-picker": Chrome,
  },
  props: {
    title: String,
    field: String,
    formName: String,
    value: String,
  },
  data() {
    return {
      color: { hex: "#40BF84" },
    };
  },
  watch: {
    value() {
      this.color.hex = this.value;
    },
    "color.hex": function (value) {
      if (value.hex) this.$emit("input", value.hex);
    },
  },
};
</script>
